import { Field, Form, Formik } from "formik";
import "moment-timezone";
import React, { Component } from "react";
import { Button, ControlLabel } from "react-bootstrap";
import Alert from "react-s-alert";
import * as Yup from "yup";
import FormikFormControl from "../Shared/Forms/FormikFormControl";
import FormikTextAreaControl from "../Shared/Forms/FormikTextAreaControl";
import TrialCoachingSessionsService from "../utils/TrialCoachingSessionsService";

class NotPresentedForm extends Component {
  render() {
    const { onCancelSubmit } = this.props;

    const validationSchema = Yup.object().shape({
      not_presented_reason: Yup.string().required("Reason is required"),
      notes_not_presented: Yup.string()
        .max(2000, "maximum 2000 characters")
        .required("Reason is required")
    });
    return (
      <Formik
        initialValues={{ not_presented_reason: "", notes_not_presented: "" }}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true);
          const { onSubmit } = this.props;
          const { deal } = this.props;
          TrialCoachingSessionsService.takeAction(
            "mark_not_presented",
            deal.id,
            values
          ).then(data => {
            Alert.success("Updated");
            onSubmit(data);
            setSubmitting(false);
          });
        }}
        render={({ errors, touched, isValid, isSubmitting }) => (
          <Form>
            <FormikFormControl
              fieldName="not_presented_reason"
              errors={errors}
              touched={touched}
            >
              <ControlLabel>Reason for not presenting</ControlLabel>
              <Field
                className="form-control input-sm"
                name="not_presented_reason"
                component="select"
              >
                <option value="">-- select --</option>
                <option value="CX_no_show_2_x_calls_and_1_x_sms">
                  CX No Show - 2x calls 1x SMS
                </option>
                <option value="sms_cancellation">SMS Cancellation</option>
                <option value="1_parent_absent">1 Parent Absent</option>
                <option value="both_parents_absent">Both Parents Absent</option>
                <option value="tech_issues">Tech Issues</option>
                <option value="parent_hasnt_seen_the_webinar">
                  Parent hasn't seen webinar
                </option>
                <option value="poor_quality_lead">Poor Quality Lead</option>
                <option value="double_booking">Double Booking</option>
                <option value="agent_no_show">Agent No Show</option>
              </Field>
            </FormikFormControl>

            <FormikTextAreaControl
              fieldLabel="Notes / Explanation"
              fieldName="notes_not_presented"
              errors={errors}
              touched={touched}
            />

            <div>
              {onCancelSubmit && (
                <Button onClick={onCancelSubmit} bsSize="small">
                  Whoops, cancel this
                </Button>
              )}
              <Button
                className="pull-right"
                disabled={!isValid || isSubmitting}
                type="submit"
                bsStyle="danger"
                bsSize="small"
              >
                Go ahead and Mark Not Presented
              </Button>
            </div>
          </Form>
        )}
      />
    );
  }
}

export default NotPresentedForm;
